import React, { useCallback } from 'react';
import { Box, Notification as WSRNotification } from '@wix/design-system';

export const Notification: React.FC<{
  show: boolean;
  message: string | JSX.Element;
}> = ({ show, message: Message }) => {
  const MessageComp = useCallback(() => {
    if (typeof Message === 'string') {
      return <>{Message}</>;
    } else if (typeof Message === 'object') {
      return Message;
    } else {
      return <></>;
    }
  }, [Message]);
  return (
    <Box position="fixed" zIndex={10000}>
      <WSRNotification
        dataHook="page-notification"
        show={show}
        theme="error"
        type="sticky"
      >
        <WSRNotification.TextLabel ellipsis={false}>
          <MessageComp />
        </WSRNotification.TextLabel>
        <WSRNotification.CloseButton size="small" />
      </WSRNotification>
    </Box>
  );
};
